import { PRODUCT_INFO_FRAGMENT, ProductInfo } from "./products";
import {
  GetProductRecommendationsQuery,
  GetProductRecommendationsQueryVariables,
} from "./shopify-storefront.graphql";
import { ShopifyStorefrontClient } from "./storefront-client";

const getProductRecommendationsQuery = /* GraphQL */ `
  ${PRODUCT_INFO_FRAGMENT}
  query getProductRecommendations($productId: ID!) {
    productRecommendations(productId: $productId) {
      ...ProductInfo
    }
  }
`;

export const getProductRecommendations = async (
  client: ShopifyStorefrontClient,
  productId: string,
): Promise<ProductInfo[]> => {
  const { data, errors } = await client.request<
    GetProductRecommendationsQuery,
    GetProductRecommendationsQueryVariables
  >(getProductRecommendationsQuery, { productId });

  if (errors) {
    if ((errors as any).graphQLErrors) {
      (errors as any).graphQLErrors.filter((error: Error) => {
        error.message.includes("totalInventory"); // this is a recoverable error
      });
    } else {
      throw errors;
    }
  }

  return data?.productRecommendations || [];
};
